import { Component, OnInit } from '@angular/core';
import { Localization } from '../../shared/enums/localization';

@Component({
  selector: 'app-account-error',
  templateUrl: './account-error.component.html',
  styleUrls: []
})
export class AccountErrorComponent implements OnInit {

  public readonly Localization = Localization;

  constructor() { }

  ngOnInit() {
  }

}
